var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionUncontrolledElement } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { CharacterCounterComponent } from "./components/character-counter";
var SurveyQuestionText = /** @class */ (function (_super) {
    __extends(SurveyQuestionText, _super);
    //controlRef: React.RefObject<HTMLInputElement>;
    function SurveyQuestionText(props) {
        return _super.call(this, props) || this;
        //this.controlRef = React.createRef();
    }
    SurveyQuestionText.prototype.renderInput = function () {
        var _this = this;
        var inputClass = this.question.getControlClass();
        var placeholder = this.question.renderedPlaceholder;
        if (this.question.isReadOnlyRenderDiv()) {
            return React.createElement("div", null, this.question.inputValue);
        }
        var counter = !!this.question.getMaxLength() ? (React.createElement(CharacterCounterComponent, { counter: this.question.characterCounter, remainingCharacterCounter: this.question.cssClasses.remainingCharacterCounter })) : null;
        return (React.createElement(React.Fragment, null,
            React.createElement("input", { id: this.question.inputId, 
                // disabled={this.isDisplayMode}
                disabled: this.question.isDisabledAttr, readOnly: this.question.isReadOnlyAttr, className: inputClass, type: this.question.inputType, 
                //ref={this.controlRef}
                ref: function (input) { return (_this.setControl(input)); }, style: this.question.inputStyle, maxLength: this.question.getMaxLength(), min: this.question.renderedMin, max: this.question.renderedMax, step: this.question.renderedStep, size: this.question.inputSize, placeholder: placeholder, list: this.question.dataListId, autoComplete: this.question.autocomplete, onBlur: function (event) { _this.question.onBlur(event); }, onFocus: function (event) { _this.question.onFocus(event); }, onChange: this.question.onChange, onClick: this.question.readOnlyBlocker, onPointerDown: this.question.readOnlyBlocker, onKeyUp: this.question.onKeyUp, onKeyDown: this.question.onKeyDown, onCompositionUpdate: function (event) { return _this.question.onCompositionUpdate(event.nativeEvent); }, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.a11y_input_ariaLabel, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-describedby": this.question.a11y_input_ariaDescribedBy, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage }),
            counter));
    };
    SurveyQuestionText.prototype.renderElement = function () {
        return (this.question.dataListId ?
            React.createElement("div", null,
                this.renderInput(),
                this.renderDataList()) :
            this.renderInput());
    };
    SurveyQuestionText.prototype.setValueCore = function (newValue) {
        this.question.inputValue = newValue;
    };
    SurveyQuestionText.prototype.getValueCore = function () {
        return this.question.inputValue;
    };
    SurveyQuestionText.prototype.renderDataList = function () {
        if (!this.question.dataListId)
            return null;
        var items = this.question.dataList;
        if (items.length == 0)
            return null;
        var options = [];
        for (var i = 0; i < items.length; i++) {
            options.push(React.createElement("option", { key: "item" + i, value: items[i] }));
        }
        return React.createElement("datalist", { id: this.question.dataListId }, options);
    };
    return SurveyQuestionText;
}(SurveyQuestionUncontrolledElement));
export { SurveyQuestionText };
ReactQuestionFactory.Instance.registerQuestion("text", function (props) {
    return React.createElement(SurveyQuestionText, props);
});
